const pointsList = [
  {
    measurement: "TE-001",
    panelId: 2,
    position: {
      top: "67.5",
      left: "22",
    },
  },
  {
    measurement: "TE-002",
    panelId: 4,
    position: {
      top: "44",
      left: "7.5",
    },
  },
  {
    measurement: "TE-003",
    panelId: 6,
    position: {
      top: "67.5",
      left: "9.3",
    },
  },
  {
    measurement: "TE-004",
    panelId: 7,
    position: {
      top: "55",
      left: "14.8",
    },
  },
  {
    measurement: "TE-005",
    panelId: 8,
    position: {
      top: "56",
      left: "46.5",
    },
  },
  {
    measurement: "TE-006",
    panelId: 9,
    position: {
      top: "30.5",
      left: "71",
    },
  },
  {
    measurement: "TE-007",
    panelId: 10,
    position: {
      top: "47",
      left: "71",
    },
  },
  {
    measurement: "TE-008",
    panelId: 11,
    position: {
      top: "72",
      left: "71",
    },
  },
  {
    measurement: "TE-009",
    panelId: 12,
    position: {
      top: "24.5",
      left: "82.2",
    },
  },
  {
    measurement: "TE-010",
    panelId: 16,
    position: {
      top: "34.5",
      left: "82.2",
    },
  },
  {
    measurement: "TE-011",
    panelId: 15,
    position: {
      top: "50",
      left: "82.2",
    },
  },
  {
    measurement: "TE-012",
    panelId: 18,
    position: {
      top: "60",
      left: "82.2",
    },
  },
  {
    measurement: "TE-013",
    panelId: 17,
    position: {
      top: "75.5",
      left: "82.2",
    },
  },
  {
    measurement: "TE-014",
    panelId: 14,
    position: {
      top: "86",
      left: "82.2",
    },
  },
  {
    measurement: "TE-015",
    panelId: 13,
    position: {
      top: "6.5",
      left: "65",
    },
  },
  {
    measurement: "TE-016",
    panelId: 22,
    position: {
      top: "26",
      left: "59",
    },
  },
  {
    measurement: "TE-017",
    panelId: 21,
    position: {
      top: "56",
      left: "41",
    },
  },
  {
    measurement: "TE-018",
    panelId: 20,
    position: {
      top: "67.5",
      left: "32.7",
    },
  },
  {
    measurement: "TE-019",
    panelId: 19,
    position: {
      top: "77",
      left: "25.5",
    },
  },
  {
    measurement: "HV-001",
    panelId: 25,
    position: {
      top: "24.3",
      left: "75.5",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-002",
    panelId: 24,
    position: {
      top: "37",
      left: "89",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-003",
    panelId: 32,
    position: {
      top: "24.3",
      left: "89",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-004",
    panelId: 31,
    position: {
      top: "51",
      left: "75.5",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-005",
    panelId: 30,
    position: {
      top: "62.5",
      left: "89",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-006",
    panelId: 29,
    position: {
      top: "51",
      left: "89",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-007",
    panelId: 28,
    position: {
      top: "77",
      left: "75.5",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-008",
    panelId: 27,
    position: {
      top: "88",
      left: "89",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-009",
    panelId: 26,
    position: {
      top: "77",
      left: "89",
    },
    waterFlow: "l-r",
  },
  {
    measurement: "HV-010",
    panelId: 33,
    position: {
      top: "31",
      left: "65.5",
    },
    waterFlow: "u-d",
  },
  {
    measurement: "HV-011",
    panelId: 34,
    position: {
      top: "20",
      left: "71.5",
    },
    waterFlow: "d-u",
  },
  {
    measurement: "P1_FE",
    panelId: 39,
    position: {
      top: "43",
      left: "33",
    },
  },
  {
    measurement: "P1_RPM",
    panelId: 38,
    position: {
      top: "39.5",
      left: "33",
    },
  },
  {
    measurement: "P1_PE",
    panelId: 36,
    position: {
      top: "36",
      left: "33",
    },
  },
  {
    measurement: "P1_PWM",
    panelId: 37,
    position: {
      top: "32.5",
      left: "33",
    },
  },
  {
    measurement: "P1_TE",
    panelId: 40,
    position: {
      top: "29",
      left: "33",
    },
  },
  {
    measurement: "P2_FE",
    panelId: 46,
    position: {
      top: "43",
      left: "42.5",
    },
  },
  {
    measurement: "P2_RPM",
    panelId: 48,
    position: {
      top: "39.5",
      left: "42.5",
    },
  },
  {
    measurement: "P2_PE",
    panelId: 42,
    position: {
      top: "36",
      left: "42.5",
    },
  },
  {
    measurement: "P2_PWM",
    panelId: 50,
    position: {
      top: "32.5",
      left: "42.5",
    },
  },
  {
    measurement: "P2_TE",
    panelId: 44,
    position: {
      top: "29",
      left: "42.5",
    },
  },

  {
    measurement: "P3_PE",
    panelId: 41,
    position: {
      top: "1",
      left: "75",
    },
  },
  {
    measurement: "P3_PWM",
    panelId: 49,
    position: {
      top: "8",
      left: "75",
    },
  },
  {
    measurement: "P3_FE",
    panelId: 45,
    position: {
      top: "8",
      left: "79.5",
    },
  },
  {
    measurement: "P3_TE",
    panelId: 43,
    position: {
      top: "1",
      left: "79.5",
    },
  },
  {
    measurement: "F2_FE",
    panelId: 60,
    position: {
      top: "71.5",
      left: "55.5",
    },
  },
  {
    measurement: "F2_PWM",
    panelId: 53,
    position: {
      top: "71.5",
      left: "51",
    },
  },
  {
    measurement: "F1_PWM",
    panelId: 52,
    position: {
      top: "83.5",
      left: "51",
    },
  },
  {
    measurement: "F1_FE",
    panelId: 59,
    position: {
      top: "83.5",
      left: "55.5",
    },
  },
  {
    measurement: "AK_P_TE",
    panelId: 57,
    position: {
      top: "38",
      left: "20.4",
    },
  },
  {
    measurement: "AK_P_PWM",
    panelId: 54,
    position: {
      top: "44.5",
      left: "20.4",
    },
  },
  {
    measurement: "AK_P_FE",
    panelId: 56,
    position: {
      top: "41.5",
      left: "20.4",
    },
  },
  {
    measurement: "AK_TE001",
    panelId: 55,
    position: {
      top: "7",
      left: "24.5",
    },
  },
  {
    measurement: "SC_PWM",
    panelId: 51,
    position: {
      top: "86",
      left: "19",
    },
  },
  {
    measurement: "O2",
    panelId: 62,
    position: {
      top: "76",
      left: "33",
    },
  },
  {
    measurement: "TE-020",
    panelId: 63,
    position: {
      top: "74",
      left: "43.5",
    },
  },
  {
    measurement: "TE-021",
    panelId: 64,
    position: {
      top: "68",
      left: "40.5",
    },
  },
  {
    measurement: "TE-022",
    panelId: 65,
    position: {
      top: "74",
      left: "37",
    },
  },
  {
    measurement: "Burning",
    panelId: 200,
    position: {
      top: "92",
      left: "40",
    },
  },
  {
    measurement: "Fan",
    panelId: 210,
    position: {
      top: "10",
      left: "48",
    },
  },
  {
    measurement: "Error",
    panelId: 220,
    position: {
      top: "95",
      left: "40.2",
    },
  },
  {
    measurement: "HV-012",
    panelId: 220,
    position: {
      top: "10",
      left: "71.5",
    },
    waterFlow: "u-d",
  },
  {
    measurement: "HV-013",
    panelId: 220,
    position: {
      top: "22",
      left: "65.5",
    },
    waterFlow: "u-d",
  },
];

export default pointsList;
